import gql from 'graphql-tag';

export default gql`
  query frontpageMetaTags {
    application(name: DESKTOPBOOKINGPATH) {
      ... on DesktopBookingPath {
        frontPageMetatagsContent
      }
    }
  }
`;
